import {
  BooleanFilterValue,
  CheckboxFilter,
  FilterType,
  FilterValue,
  InputType,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useTranslation } from "@coworker/locales";
import { LOCATION_ID } from "./useLocationFilter";
import { getSelectedFilterValue } from "@coworker/apprestructured/src/shared/filters/utils/filter/filtervalue";

export const QUESTIONS_WITH_TASKS_ONLY_ID = "questionsWithTasksOnlyFilter";

export const DEFAULT_QUESTIONS_WITH_TASKS_ONLY_VALUE: BooleanFilterValue = {
  filterId: QUESTIONS_WITH_TASKS_ONLY_ID,
  value: false,
};

export function useQuestionsWithTasksOnlyFilter(
  filterValues: FilterValue[],
  hideQuestionsWithTasksOnly: boolean
): CheckboxFilter {
  const { t } = useTranslation();
  const isWholeStore = !filterValues.some(
    (filter) => filter.filterId === "location"
  );

  const defaultValue = DEFAULT_QUESTIONS_WITH_TASKS_ONLY_VALUE;
  const checked = getSelectedFilterValue(
    QUESTIONS_WITH_TASKS_ONLY_ID,
    filterValues,
    defaultValue
  );

  return {
    inputType: InputType.Checkbox,
    filterType: FilterType.Filter,
    id: QUESTIONS_WITH_TASKS_ONLY_ID,
    title: t("questionsWithTasksOnlyString"),
    defaultValue: checked,
    enabled: !isWholeStore && !hideQuestionsWithTasksOnly,
    dependsOnFilterId: LOCATION_ID,
  };
}
